import { render, staticRenderFns } from "./EcoScoreSection.vue?vue&type=template&id=29ce9d26&scoped=true&"
import script from "./EcoScoreSection.vue?vue&type=script&lang=ts&"
export * from "./EcoScoreSection.vue?vue&type=script&lang=ts&"
import style0 from "./EcoScoreSection.vue?vue&type=style&index=0&id=29ce9d26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ce9d26",
  null
  
)

export default component.exports